"use client";

import React from "react";
import { createAppKit } from "@reown/appkit/react";
import { defineChain } from '@reown/appkit/networks';
import {
  mainnet,
  arbitrum,
  bsc,
  polygon,
  fantom,
  bscTestnet,
} from "@reown/appkit/networks";
import { Ethers5Adapter } from "@reown/appkit-adapter-ethers5";

const projectId = "39c72f98d2c418db57119ec2ad6cec30";

const metadata = {
  name: "OPENCOIN",
  description: "Opencoin Platform",
  url: "https://opencoinstake.io",
  icons: ["https://opencoinstake.io/favicon.png"],
};

const customNetwork = defineChain({
  id: 31337,
  caipNetworkId: 'eip155:31337',
  chainNamespace: 'eip155',
  name: 'Foundry',
  nativeCurrency: {
    decimals: 18,
    name: 'Ether',
    symbol: 'ETH',
  },
  rpcUrls: {
    default: {
      http: ['http://localhost:8546'],
      // webSocket: ['WS_RPC_URL'],
    },
  },
  blockExplorers: {
    default: { name: 'Explorer', url: 'BLOCK_EXPLORER_URL' },
  },
  contracts: {
    // Add the contracts here
  }
})

createAppKit({
  adapters: [new Ethers5Adapter()],
  networks: [
    // mainnet, 
    bsc, 
    // polygon, 
    // arbitrum, 
    // fantom, 
    // bscTestnet,
    // customNetwork
  ],
  metadata,
  projectId,
  features: {
    analytics: true,
  },
  defaultNetwork: customNetwork,
});

export function Web3EVMModal({ children }) {
  return <div className="">{children}</div>;
}
